import api from "./api";
import { updateAuthUser } from "../utils/auth";

const ensureArray = (value) =>
  Array.isArray(value) ? value : [];

export const normalizeCurrentUserPayload = (payload = {}) => ({
  ...payload,

  emp_id: payload.emp_id || "",
  role: payload.role || "",
  name: payload.name || "",
  status: payload.status || "",

  team:
    payload.team ||
    payload.team_name ||
    "",

  team_name:
    payload.team_name ||
    payload.team ||
    "",

  department:
    payload.department ||
    payload.team ||
    payload.team_name ||
    "",

  designation:
    payload.designation ||
    payload.designation_name ||
    "",

  designation_name:
    payload.designation_name ||
    payload.designation ||
    "",

  designation_id:
    payload.designation_id ?? null,

  designation_level:
    payload.designation_level ?? null,

  branch_id:
    payload.branch_id ?? null,

  branch_name:
    payload.branch_name || "",

  zone_id:
    payload.zone_id ?? null,

  zone_name:
    payload.zone_name || "",

  primary_branch_id:
    payload.primary_branch_id ?? null,

  primary_zone_id:
    payload.primary_zone_id ?? null,

  crm_branch_ids:
    ensureArray(payload.crm_branch_ids),

  crm_branch_names:
    ensureArray(payload.crm_branch_names),

  crm_zone_ids:
    ensureArray(payload.crm_zone_ids),

  all_branch_ids:
    ensureArray(payload.all_branch_ids),

  all_branch_names:
    ensureArray(payload.all_branch_names),

  scope_owner_mappings:
    ensureArray(payload.scope_owner_mappings),

  managed_team_ids:
    ensureArray(payload.managed_team_ids),

  managed_team_names:
    ensureArray(payload.managed_team_names),

  module_access:
    ensureArray(payload.module_access),

  profile_photo:
    payload.profile_photo || null,

  two_factor_enabled:
    Boolean(payload.two_factor_enabled),
});

export const refreshCurrentAuthUser = async (options = {}) => {
  const response = await api.get("/auth/me", {
    ...options,
  });

  const normalizedUser =
    normalizeCurrentUserPayload(response?.data || {});

  updateAuthUser(normalizedUser);

  return normalizedUser;
};
